import { IExperimentResultSchema } from '../../repositories/ab-use/entities/entities/ExperimentResultSchema';

export const getExperiment = (
  experiments: IExperimentResultSchema[],
  experimentName: string,
): IExperimentResultSchema | undefined => {
  return experiments.find(o => o.experimentName === experimentName);
};
